import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import xss from "xss";

import { mapNationality, mapPersonenart } from "../../utils/mapping/KundendatenMap";
import SelectKonto from "./SelectKonto";
import { kundenActions } from "../../actions";
import { Tooltip } from "../../utils/components/Tooltip";
import PERSONART from "../../utils/enums/PERSONART";

const KundenDaten = (props) => {
  const dispatch = useDispatch();
  const kunde = useSelector((store) => store.kundenStorage.getKunde()) || {};
  const isVerseNeo = useSelector((store) => store.configStorage.isVerseNeo);
  const isDeuBa = useSelector((store) => store.configStorage.isDeuBa);
  const getBankId = useSelector((store) => store.configStorage.getBankId);
  const isCompany = (kunde.personArt === PERSONART.JURISTISCHE_PERSON.KUERZEL);        

  //dropdown Gebietsansaessiger
  const isGebietsansaessiger = kunde.gebietsansaessigKz?.toString();
  const [selectedOption, setSelectedOption] = useState(isGebietsansaessiger);
  //In React, the initial state is set only once, when the component is mounted.
  //To ensure that the initial value of isGebietsansaessiger is correctly selected in the dropdown, 
  //we set the selected option once more in the useEffect hook.
  //if we don't do this then the dropdown will not have the initial value(that is coming from "kunde") selected.
  useEffect(() => {
    if (typeof isGebietsansaessiger === "undefined" || isGebietsansaessiger === null) {
      setSelectedOption("2");
    } else {
      setSelectedOption(isGebietsansaessiger);
    }
  }, [isGebietsansaessiger]);
  const handleChange = async (event) => {
    const selectedValue = xss(event.target.value);
    kunde.gebietsansaessigKz = event.target.value === "0" || event.target.value === "1" ? Number(event.target.value) : undefined;
    dispatch(kundenActions.setKunde(kunde));
    setSelectedOption(selectedValue);
  };
  const optionValue = kunde.gebietsansaessigKz === 1 ? "Ja" : "Nein";
  const checkIban = String(kunde.kundenkonto).replace(/\s+/g, "");
  const blz = new RegExp("DE.." + getBankId());
  const warnWrongIban = !!getBankId() && !checkIban.match(blz) && !isDeuBa;
  return (<>
    <h3 className="fw-bold text-gray">
      Kundendaten      
    </h3>
    <table className="table table-bordered table-responsive-xs w-100">
      <tbody>
        <tr>
          <th className="active">{isCompany ? "Firmenname:" : "Name:"}</th>
          <td>
            {!isCompany ? kunde.vorname : ""} {kunde.nachname}
          </td>
        </tr>
        {kunde.namenszusatz
          ? <tr>
            <th className="active">Namens&shy;zusatz:</th>
            <td>
              {kunde.namenszusatz}
            </td>
          </tr>
          : null
        }
        <tr>
          <th className="active">Adresse:</th>
          <td>
            {kunde.strasse1} {kunde.strasse2 ? kunde.strasse2 : ""} <br />{kunde.plz} {kunde.ort}
          </td>
        </tr>
        <tr>
          <th className="active">Kontonummer:</th>
          <td >
            {props.renderDropdown
              ? <SelectKonto id="Kontofeld" aria-label="Kontonummer"/>
              : kunde.kundenkonto
            }
            {warnWrongIban
              ? <div className="alert alert-warning p-1">WARNUNG: Das Konto passt nicht zur BLZ des Instituts.</div>
              : null
            }
          </td>
        </tr>
        {kunde.email
          ? <tr>
            <th className="active">Email:</th>
            <td>
              {kunde.email}
            </td>
          </tr>
          : null
        }
        {!isCompany
          ? (
            <>
              <tr>
                <th className="active">Geburtsdatum:</th>
                <td>
                  {kunde.gebDatKunde}
                </td>
              </tr>
              {kunde.gebOrtKunde && !String(kunde.gebOrtKunde).match(/(null|undefined)/i)
                ? <tr>
                  <th className="active">Geburtsort:</th>
                  <td>
                    {kunde.gebOrtKunde}
                  </td>
                </tr>
                : null
              }
              <tr>
                <th className="active">Nationalität:</th>
                <td>
                  {mapNationality(kunde.nationalitaet).Langbezeichnung}
                </td>
              </tr>
            </>
          )
          : null
        }
        <tr>
          <th className="active">Gebiets&shy;ansässiger:</th>
          <td>
            {props.renderDropdown
              ? <div className="row mt-one-half mb-one-half align-items-center">
                <div className="col-9 col-md-5">
                  <select
                    id="gebietsansaessiger"
                    aria-label="Gebietsansässiger"
                    className={kunde.gebietsansaessigKz === 1 || kunde.gebietsansaessigKz === 0 ? "form-select" : "form-select is-invalid"}
                    value={selectedOption}
                    onChange={handleChange}>
                    <option value="">--Bitte auswählen--</option>
                    <option value="1">Ja</option>
                    <option value="0">Nein</option>
                  </select>
                </div>
                <Tooltip className="col-1">Personen mit Wohnsitz oder gewöhnlichem Aufenthaltsort im Inland.</Tooltip>
              </div>
              : optionValue
            }
          </td>
        </tr>
        {!isVerseNeo()
          ? <tr>
            <th className="active">Personenart:</th>
            <td>
              {mapPersonenart(kunde.personArt)}
            </td>
          </tr>
          : null
        }
      </tbody>
    </table>
  </>);
};

export default KundenDaten;
